var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.047,
    height: 14.046,
    viewBox: "0 0 14.047 14.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1048",
    "data-name": "Grupo 1048",
    transform: "translate(17829.977 5783.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-17830.74 -5784.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2116467169744",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_429",
    "data-name": "Trazado 429",
    d: "M72.233,65.21a7.023,7.023,0,1,1-7.023,7.023A7.023,7.023,0,0,1,72.233,65.21Z",
    transform: "translate(-64.446 -64.446)",
    fill: "#4a8cff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "monitor",
    transform: "translate(-17828.434 -5782.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_2496",
    "data-name": "Rect\\xE1ngulo 2496",
    d: "M.117-1.25H6.845A1.368,1.368,0,0,1,8.212.117V4.322A1.368,1.368,0,0,1,6.845,5.689H.117A1.368,1.368,0,0,1-1.25,4.322V.117A1.368,1.368,0,0,1,.117-1.25ZM6.845,4.637a.316.316,0,0,0,.315-.315V.117A.316.316,0,0,0,6.845-.2H.117A.316.316,0,0,0-.2.117V4.322a.316.316,0,0,0,.315.315Z",
    transform: "translate(2 3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_493",
    "data-name": "L\\xEDnea 493",
    d: "M2.64-.2H-.724A.526.526,0,0,1-1.25-.724.526.526,0,0,1-.724-1.25H2.64a.526.526,0,0,1,.526.526A.526.526,0,0,1,2.64-.2Z",
    transform: "translate(4.523 10.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_494",
    "data-name": "L\\xEDnea 494",
    d: "M-.724,1.483A.526.526,0,0,1-1.25.958V-.724A.526.526,0,0,1-.724-1.25.526.526,0,0,1-.2-.724V.958A.526.526,0,0,1-.724,1.483Z",
    transform: "translate(6.205 8.887)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.a5b09288c7cb56ec99816e967abe9ca6.svg";
export { ForwardRef as ReactComponent };